"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledContent = _styledComponents.default.div`
    box-sizing: border-box;
    width: 100%;
    padding-top: 1px;
    margin-top: -1px;
    min-height: calc(100vh - 50px);

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
var _default = StyledContent;
exports.default = _default;